import type { ResourceProps } from 'react-admin';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

import TradeinList from './TradeinList';

const tradeinsResource: Omit<ResourceProps, 'children'> = {
  name: 'tradeins',
  list: TradeinList,
  icon: SwapHorizIcon,
  options: { label: 'Trade-ins' },
};

export default tradeinsResource;
export { tradeinsDataProvider } from './dataProvider';
export type { TradeinRecord } from './types';
